export const EDITOR_CHOICE_DESCRIPTION_MAX_LENGTH = 80

export type KnownSectionId = 'bi' | 'top_games' | 'popular_videos' | 'featured_experiences'

export const KNOWN_SECTION_IDS = [
  'bi',
  'top_games',
  'popular_videos',
  'featured_experiences',
] as const satisfies KnownSectionId[]
